/* eslint-disable */
import Collapse from "../../node_modules/bootstrap.native/src/components/collapse-native.js";
import Swiper, {Navigation, Pagination, Scrollbar, Autoplay} from "swiper";
import Header from "./module/header";
import Fragebogen from "./module/fragebogen";
import ToggleItems from "./module/toggle-items";
import Youtube from "./module/youtube";
import Accordion from "./module/accordion";
import Video from "./module/video";
import Leistungenv2 from "./module/leistungen-v2";
import BlogListing from './module/blog.js';

Swiper.use([Navigation, Pagination, Scrollbar, Autoplay]);

window.addEventListener('load', () => {

    /** Scroll in header */
    if (document.getElementById('header')) {
        new Header(document.getElementById('header'));
    }

    /** Blog */
    document.querySelectorAll('[data-blog]').forEach(elem => {
        new BlogListing(elem.closest('.blog'));
    });

    /** Toggle List */
    document.querySelectorAll('[data-toggle="collapse"]').forEach(elem => {
        // elem.Collapse = new Collapse(elem);
    });
    /** Toggle List */
    document.querySelectorAll('.accordion').forEach(elem => {
        new Accordion(elem);
    });
    /** Toggle List */
    document.querySelectorAll('[data-leistungen-v2]').forEach(elem => {
        new Leistungenv2(elem);
    });

    /** Youtube Slider Wrapper */
    document.querySelectorAll('[data-youtube]').forEach(elem => {
        elem.Youtube = new Youtube(elem);
    });

    /** Youtube Slider Wrapper */
    document.querySelectorAll('[data-video-id]').forEach(elem => {
        elem.Video = new Video(elem, {
            openVideo: '.contact-teaser-video'
        });
    });

    /** Toggle List */
    document.querySelectorAll('[data-call-toggle="collapse"]').forEach(elem => {
        //  elem.Collapse = new Collapse(elem);
    });

    /** Fragebogen */
    document.querySelectorAll('[data-cheet]').forEach(elem => {
        elem.Fragebogen = new Fragebogen(elem);
    });

    /** Gallery */
    document.querySelectorAll('.slider').forEach(function (elem) {
        const swiperElem = elem.querySelector('.swiper-container');
        const id = elem.getAttribute('id');

        const options = {
            loop: true,
            slideClass: 'hero',
            allowClick: true,
            autoHeight: false,
            observer: true,
            observeParents: true,
            grabCursor: true,
            pagination: {
                clickable: true,
                el: document.getElementById(`${id}-pagination`),
                type: 'bullets',
            },
            navigation: {
                nextEl: document.getElementById(`${id}-next`),
                prevEl: document.getElementById(`${id}-prev`),
            },
            autoplay: {
                enabled: false,
                duration: elem.dataset.duration
            },
            on: {
                init(a) {
                    a.$el[0].querySelectorAll('.lqip-lazy-loader').forEach((e) => {
                        // eslint-disable-next-line
                        new LqipLazyLoader(e, {
                            useIntersection: false,
                        });
                    });
                },
            },
        };

        // eslint-disable-next-line
        const sw = new Swiper(swiperElem, options);
    });

    /** Citer slider */
    document.querySelectorAll('.cite-slider').forEach((elem) => {

        const swiperElem = elem.querySelector('.swiper-container');
        const id = elem.getAttribute('id');

        const options = {
            autoHeight: true,
            loop: true,
            slideClass: 'swiper-slide',
            allowClick: true,
            observer: true,
            observeParents: true,
            grabCursor: true,
            pagination: {
                clickable: true,
                el: document.getElementById(`${id}-pagination`),
                type: 'bullets',
            },
            navigation: {
                nextEl: document.getElementById(`${id}-next`),
                prevEl: document.getElementById(`${id}-prev`),
            },
            autoplay: {
                enabled: true,
                duration: 3000
            }
        };

        // eslint-disable-next-line
        const sw = new Swiper(swiperElem, options);
    })

    /** Youtube slider */
    document.querySelectorAll('.youtube-slider-wrapper').forEach((elem) => {

        const swiperElem = elem.querySelector('.swiper');
        const id = elem.getAttribute('id');

        const options = {
            autoHeight: true,
            loop: false,
            slideClass: 'swiper-slide',
            allowClick: true,
            navigation: {
                nextEl: document.getElementById(`${id}-next`),
                prevEl: document.getElementById(`${id}-prev`),
            },
            slidesPerView: 1.5,
            spaceBetween: 10,
            breakpoints: {
                640: {
                    slidesPerView: 2.5,
                    spaceBetween: 20,
                },
                768: {
                    slidesPerView: 3.5,
                    spaceBetween: 40,
                }
            },
        };

        elem.youtubeSwiper = new Swiper(swiperElem, options);
    })

    /** Toggle Text */
    document.querySelectorAll('[data-toggletext]').forEach((elem) => {
        const h = elem.querySelector('.toggletext-link');
        const c = elem.querySelector('.toggletext-content');
        const x = elem.querySelector('.toggletext-close');

        if (typeof x != 'undefined' && x != null) {
            x.addEventListener('click', () => {
                c.classList.remove('d-block');
            })
        }

        h.addEventListener('click', () => {
            c.classList.toggle('d-block');
        })
    });

    document.querySelectorAll('#nav .toggler').forEach((elem) => {
        const e = elem;

        elem.addEventListener('click', () => {

            document.querySelectorAll('#nav .toggler').forEach((b) => {
                if (e !== b) {

                    b.classList.remove('open');
                }
            });

            e.classList.toggle('open');
        });
    });

    const flyout = document.getElementById('contact-flyout') || false;

    if (flyout) {
        Array.from(document.querySelectorAll('.contact-flyout-toggle')).forEach((elem) => {
            elem.addEventListener('click', () => {
                flyout.classList.toggle('is-open');
            })
        });
    }

    Array.from(document.querySelectorAll('[data-toggle-items]')).forEach((elem) => {
        new ToggleItems(elem);
    })
});
